<!-- <ion-header [translucent]="true">
  <ion-toolbar>
    <ion-title>admin</ion-title>
  </ion-toolbar>
</ion-header>

<ion-content [fullscreen]="true">
  <ion-header collapse="condense">
    <ion-toolbar>
      <ion-title size="large">Admin Panel</ion-title>
    </ion-toolbar>
  </ion-header>
</ion-content> -->


<ion-header [translucent]="true">
  <ion-toolbar>
      <ion-title>Admin Panel</ion-title>
      <ion-buttons slot="end">
        <!-- <ion-title style="cursor: pointer;" size="large" (click)="goToAdminPage()">Admin</ion-title>
        <ion-title style="cursor: pointer;" size="large" (click)="confirmLogout()">Logout</ion-title> -->
        <ion-title style="cursor: pointer;" size="large" (click)="goToMenu()">Menu</ion-title>
        <ion-title style="cursor: pointer;" size="large" (click)="confirmLogout()">Logout</ion-title>
    </ion-buttons>
  </ion-toolbar>
</ion-header>

<ion-content [fullscreen]="true">
  <ion-header collapse="condense">
    <ion-toolbar>
      <ion-title size="large">menu</ion-title>
    </ion-toolbar>
  </ion-header>


  <ion-grid>
    <ion-row>
      
      <ion-col size="6" size-md="4">
        <ion-card (click)="goToAllHistory()">
        <!-- <ion-card> -->
          <ion-card-header>
            <ion-card-title style="cursor: pointer;" size="large">All History</ion-card-title>
          </ion-card-header>
          <ion-card-content>
            Click here to view all user's data !!!
          </ion-card-content>
        </ion-card>
      </ion-col>
      <ion-col size="6" size-md="4">
        <!-- <ion-card (click)="goToHistoryPage()" -->
        <!-- <ion-card class="low-visibility"> -->
        <ion-card class="low-visibility" style="visibility: hidden;">
          <ion-card-header>
            <ion-card-title>Users</ion-card-title>
          </ion-card-header>
          <ion-card-content>
            Click here to see Users !!!
          </ion-card-content>
        </ion-card>
      </ion-col>
      <ion-col size="6" size-md="4">
        <!-- <ion-card (click)="goToModelMenu()"> -->
        <!-- <ion-card  class="low-visibility"> -->
        <ion-card  class="low-visibility" style="visibility: hidden;">
          <ion-card-header>
            <ion-card-title>Add Model</ion-card-title>
          </ion-card-header>
          <ion-card-content>
            Click here to Add Model !!!
          </ion-card-content>
        </ion-card>
      </ion-col>
      
      <!-- Add more columns as needed -->
    </ion-row>
  </ion-grid>
</ion-content>
